import { createTheme } from '@material-ui/core/styles';

export const customTheme = createTheme({
    palette: {
        primary: {
            main: "#FFCC33"
        },
        secondary: {
            main: "#000"
        }
    },
    overrides: {
        // targeting refresh button
        RaAppBar: {
            toolbar: {
                '& button': {
                    '&:not(:nth-child(1))': {
                        display: 'none'
                    }
                }
            }
        },
        RaFormInput: {
            input:{
                width: '50%'
            }
        }
    }
})
